import React from 'react';

import FileUploadFieldValueWrapper from 'components/form-controls/FileUploadFieldValueWrapper';
import { currentLanguage } from 'helpers/utils';
import { Button, NamedProperty } from 'ui';

function ProductCustomFieldValueRender({
  value,
  customField,
}: {
  value: any;
  customField: Backend.ProductCustomFieldType;
}) {
  switch (customField.type) {
    case 'SELECT':
      return <span>{currentLanguage(customField.options?.find((o) => o.id === value)?.label) || '–'}</span>;
    case 'DATE':
      return <span>{value ? moment(value).format('LL') : '–'}</span>;
    case 'CHAR':
      return <span>{value || '–'}</span>;
    case 'MULTILINE':
      return <span className="whitespace-pre-line">{value || '–'}</span>;
    case 'LINK':
      return value ? (
        <a href={value.url} target="_blank" rel="noreferrer">
          <Button link>{value.text}</Button>
        </a>
      ) : (
        <span>–</span>
      );
    case 'FILE':
      return value && value.length > 0 ? <FileUploadFieldValueWrapper value={value} /> : <span>–</span>;
    default:
      return null;
  }
}

type Props = {
  customFields: { [key: string]: string | string[] };
  customField: Backend.ProductCustomFieldType;
};

function ProductCustomFieldValue({ customFields, customField }: Props) {
  const value = customFields[customField.id];

  if (customField.is_internal && !value) {
    return null;
  }

  return (
    <NamedProperty
      name={currentLanguage(customField.name)}
      value={<ProductCustomFieldValueRender customField={customField} value={value} />}
    />
  );
}

export default ProductCustomFieldValue;
